import { FC, useEffect, useMemo } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/ChangePassword/ChangePassword.module.scss'
import { Button } from '@src/components/Button/Button'
import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { validateForm } from '@src/messages/validateForm'
import { sendNewPassword } from '@src/store/ducks/auth/thunks'
import { resetState } from '@src/store/ducks/auth/reducer'
import { AppDispatch } from '@src/store/store'
import { isString } from '@src/lib/utils'
import { selectBackError } from '@src/store/ducks/auth/selectors'

const validationSchema = Yup.object().shape({
  oldPassword: Yup.string().required(validateForm.required),
  password: Yup.string().required(validateForm.required)
    .notOneOf([Yup.ref('oldPassword')], 'Новый пароль идентичен старому')
    .min(8, 'Минимальная длина строки 8 символов'),
  confirmPassword: Yup.string().required(validateForm.required)
    .oneOf([Yup.ref('password'), null], 'Пароли не совпадают')
    .min(8, 'Минимальная длина строки 8 символов'),
})

type ChangePasswordFormProps = {
  isLoading: boolean
}

export const ChangePasswordForm:FC<ChangePasswordFormProps> = ({ isLoading }) => {
  const dispatch = useDispatch<AppDispatch>()
  const backError = useSelector(selectBackError)

  const initialValues = useMemo(() => ({ oldPassword: '', password: '', confirmPassword: '' }), [])

  useEffect(() => () => {
    dispatch(resetState())
  }, [dispatch])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(value) => {
        dispatch(sendNewPassword(value))
      }}
      validationSchema={validationSchema}
    >
      {() => (
        <Form>
          <div className={style.box_1}>
            <FieldFormik
              name="oldPassword"
              type="password"
              placeholder="Старый пароль"
              label="Введите Ваш старый пароль"
            />
            <FieldFormik
              name="password"
              type="password"
              placeholder="Новый пароль"
              label="Введите новый пароль"
            />
            <FieldFormik
              name="confirmPassword"
              type="password"
              placeholder="Подтвердите новый пароль"
              label="Подтвердите новый пароль"
            />
          </div>
          {backError && isString(backError) && <div className={style.error}>{backError}</div>}
          <div className={`${style.btn}`}>
            <Button
              loading={isLoading}
              htmlType="submit"
              type="primary"
              className={style.btnSize}
            >
              Подтвердить
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}
